import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import { useRouter } from 'next/router'
import { Flex, GridLayout, Icon, Typography, useDisclosure } from '@nilohealth/core-ui'
import * as Dropdown from '@radix-ui/react-dropdown-menu'

import { useSitemap } from '@dashboard/dashboard.hooks'

import { useEffect, useMemo, useState } from 'react'
import {
  DashboardTextLink,
  DashboardsTrigger,
  DashboardsContent,
  DashboardsCategoryList,
  DashboardsIndicatorList,
  DashboardIndicatorContent,
} from './dashboards.styles'
import DashboardsCategory from './dashboards-category'

const Dashboards = () => {
  const router = useRouter()

  const { isOpen, setIsOpen } = useDisclosure()

  const { sitemap } = useSitemap()

  const [activeCategoryId, setActiveCategory] = useState(0)

  const activeCategory = sitemap?.category?.find(category => category.id === activeCategoryId)

  const activeIndicators = useMemo(() => {
    return sitemap?.indicator?.filter(indicator => indicator.categoryId === activeCategoryId) ?? []
  }, [sitemap, activeCategoryId])

  const hoverIn = (id: number) => {
    setActiveCategory(id)
  }

  const openDashboard = () => {
    if (activeCategory) {
      setIsOpen(false)
      router.push(`/${activeCategory.slug}`)
    }
  }

  useEffect(() => {
    setActiveCategory(0)
  }, [isOpen])

  return (
    <Flex>
      <Dropdown.Root open={isOpen} onOpenChange={setIsOpen}>
        <DashboardsTrigger active={isOpen}>
          <Flex gap="quarck">
            <Typography type="subtitleXSmall" weight="medium" color="neutralLowDark" truncate>
              Categorias e indicadores
            </Typography>

            <Icon icon={MdOutlineKeyboardArrowDown} size="small" />
          </Flex>
        </DashboardsTrigger>

        <Dropdown.Portal>
          <DashboardsContent sideOffset={16}>
            <GridLayout>
              <DashboardsCategoryList>
                <Typography type="paragraphXXSmall" weight="regular" color="neutralLowMedium">
                  Categorias
                </Typography>

                <Flex direction="column" gap="none">
                  {sitemap?.category?.map(category => (
                    <DashboardsCategory
                      key={category.id}
                      category={category}
                      isActive={activeCategoryId === category.id}
                      hoverIn={hoverIn}
                      openDashboard={openDashboard}
                    />
                  ))}
                </Flex>
              </DashboardsCategoryList>

              <DashboardsIndicatorList>
                {activeCategory ? (
                  <>
                    <Typography type="paragraphXXSmall" weight="regular" color="neutralLowMedium">
                      Indicadores em {activeCategory.name}
                    </Typography>

                    <DashboardIndicatorContent direction="column" gap="xxsmall">
                      {activeIndicators.map(indicator => (
                        <DashboardTextLink key={indicator.id} href={`/${indicator.slug}`}>
                          {indicator.name}
                        </DashboardTextLink>
                      ))}
                    </DashboardIndicatorContent>
                  </>
                ) : null}
              </DashboardsIndicatorList>
            </GridLayout>
          </DashboardsContent>
        </Dropdown.Portal>
      </Dropdown.Root>
    </Flex>
  )
}

export default Dashboards
